import { helpers } from 'vuelidate/lib/validators'

export const slug = value => !helpers.req(value) || /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(value)
